import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { formatCurrency } from "../../utils/utils";

interface IncomeSummaryProps {
  data: any;
}

const BookingIncomeSummary: React.FC<IncomeSummaryProps> = ({ data }) => {
  const styles = {
    fontSize: "0.75rem",
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        mb: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{ mb: 1, fontWeight: 600, fontSize: "0.85rem" }}
      >
        Income Summary
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: { xs: 1, sm: 1, md: 0 },
          justifyContent: { md: "space-between" },
        }}
      >
        {/* Base Income */}
        <Box sx={{ width: { xs: "50%", sm: "50%", md: "20%" } }}>
          <Typography variant="subtitle2" color="text.secondary" sx={styles}>
            Total Income (excl. GST)
          </Typography>
          <Typography variant="h6" sx={styles}>
            {formatCurrency(data?.amountBeforeGst || 0)}
          </Typography>
        </Box>
        <Box sx={{ width: { xs: "50%", sm: "50%", md: "10%" } }}>
          <Typography variant="subtitle2" color="text.secondary" sx={styles}>
            GST %
          </Typography>
          <Typography variant="h6" sx={styles}>
            {data?.gstPercentage || 0}%
          </Typography>
        </Box>
        <Box sx={{ width: { xs: "50%", sm: "50%", md: "15%" } }}>
          <Typography variant="subtitle2" color="text.secondary" sx={styles}>
            GST Amount
          </Typography>
          <Typography variant="h6" sx={styles}>
            {formatCurrency(data?.totalGstAmount || 0)}
          </Typography>
        </Box>
        <Box sx={{ width: { xs: "50%", sm: "50%", md: "15%" } }}>
          <Typography variant="subtitle2" color="text.secondary" sx={styles}>
            Paid Amount
          </Typography>
          <Typography variant="h6" sx={styles}>
            {formatCurrency(data?.totalPayments || 0)}
          </Typography>
        </Box>
        <Box sx={{ width: { xs: "50%", sm: "50%", md: "15%" } }}>
          <Typography variant="subtitle2" color="text.secondary" sx={styles}>
            Balance Amount
          </Typography>
          <Typography variant="h6" sx={styles}>
            {formatCurrency(data?.balanceAmount || 0)}
          </Typography>
        </Box>
        <Box sx={{ width: { xs: "50%", sm: "50%", md: "20%" } }}>
          <Typography variant="subtitle2" color="text.secondary" sx={styles}>
            {data?.incomeType === "perkm"
              ? "Estimated Total Income (incl. GST)"
              : "Total Income (incl. GST)"}
          </Typography>
          <Typography variant="h6" sx={styles}>
            {formatCurrency(data?.amountAfterGst || 0)}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default BookingIncomeSummary;
